export default "__VITE_ASSET__Br$b7Wtd__"